<template>
  <div>
    <button @click="toggleIsOpen">
      <slot name="MenuButton"></slot>
    </button>
    <template v-if="isOpen">
      <transition name="mask">
        <div
          class="menu__mask"
          @click="onClose"
          @keydown.esc="onClose"
        ></div>
      </transition>
      <div class="menu__content">
        <div class="menu__items">
          <slot name="MenuItems">
          </slot>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleIsOpen() {
      this.isOpen = !this.isOpen;
    },
    onClose() {
      this.isOpen = false;
    }
  }
};
</script>

<style scoped>
@import './menu.css';
</style>
